<template>
  <div class="component-select" @mouseover="changeEventHandler" @mouseout="changeEventHandler">
    <div class="component-select-wrap">
      <CheckInput
        class="input-select noevent z2 w-normal"
        :isFocus="inputFocus"
        :isHover="inputHover"
        :label="label"
        :placeholder="placeholder"
        v-model="inputVal"
        :disable="disable"
        :error="error"
        :isCheck="false"
        :errmsg="errmsg"
        :id="id"
      />
      <div class="triangle-down z2" :class="selectVisible ? 'up' : ''"></div>
      <el-select
        :value="inputVal"
        class="el-select overlay "
        :placeholder="placeholder"
        @focus="changeEventHandler"
        @change="onSelectChange"
        @blur="changeEventHandler"
        @visible-change="visibleChagneHandler($event)"
        :disabled="disable"
        ref="select"
      >
        <el-option class="w-normal" v-for="(item, index) in options" :key="'option_' + index" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <div v-if="isVerific && ((startVerific && error) || error)" class="errmsg">{{ errmsg }}</div>
    </div>
  </div>
</template>
<script>
/**
 * 下拉框组件
 * @module Select
 */
import CheckInput from '../CheckInput/checkInput';
export default {
  name: 'Select',
  /**
   * @prop {String} label 组件标签
   * @prop {String} value 组件数据
   * @prop {Array} options 下拉框数据
   * @prop {Boolena} disable 是否禁用 默认false
   * @prop {Boolena} startVerific 是否开启验证
   * @prop {Boolean} error 是否错误 默认false
   */
  props: {
    label: {
      type: String,
      default: '测试呀'
    },
    // 默认值
    value: {
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return [
          {
            value: '选项1',
            label: '黄金糕'
          },
          {
            value: '选项2',
            label: '双皮奶'
          },
          {
            value: '选项3',
            label: '蚵仔煎'
          },
          {
            value: '选项4',
            label: '龙须面'
          },
          {
            value: '选项5',
            label: '北京烤鸭'
          }
        ];
      }
    },
    disable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    startVerific: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    errmsg: {
      type: String,
      default: '请选择'
    },
    isError: {
      type: Boolean,
      default: false
    },
    isVerific: {
      type: Boolean,
      default: true
    }
  },
  /**
   * @prop {Component} CheckInput 带验证的输入框组件
   */
  components: {
    CheckInput
  },
  /**
   * @prop {Boolean} inputHover 输入框hover状态
   * @prop {Boolean} inputFocs 输入框focus状态
   * @prop {Boolean} selectVisible 选项是否可见
   * @prop {String} inputVal 作为显示的input 的val
   * @prop {String} isOk 选择框报错状态 的val
   */
  data() {
    return {
      inputHover: false,
      inputFocus: false,
      selectVisible: false,
      error: false, // 选择框报错状态
      inputVal: ''
    };
  },
  mounted() {
    let label = this.valueToLabel(this.value);
    if (label) this.inputVal = label;
    if (this.startVerific && this.isVerific) {
      this.error = this.inputVal === '' ? true : false;
    }
  },
  watch: {
    isError() {
      this.error = this.isError;
    },
    options() {
      let label = this.valueToLabel(this.value);
      if (label) this.inputVal = label;
      if (this.startVerific && this.isVerific) {
        this.error = this.inputVal === '' ? true : false;
      }
    },
    startVerific() {
      if (this.startVerific && this.isVerific) {
        this.error = this.inputVal === '' ? true : false;
      }
    },
    // 反向 跟踪
    value(val) {
      let label = this.valueToLabel(val);
      if (label) this.inputVal = label;
      console.log(val);

      // if (this.startVerific) this.checkSelectInput();
      if (this.startVerific && this.isVerific) {
        this.error = this.inputVal === '' ? true : false;
      }
    }
  },
  methods: {
    /**
     * @description 监听 按钮状态 切换背景颜色
     * @function changeEventHandler
     * @param {Object} event 事件对象
     */
    changeEventHandler(event) {
      const that = this;
      let eventType = event.type;
      switch (eventType) {
        case 'mouseover':
          if (that.error) return;
          if (that.disable) return;
          that.inputHover = true;
          break;
        case 'mouseout':
          if (that.inputFocus) return;
          if (that.error) return;
          if (that.disable) return;
          // that.inputFocus = false;
          that.inputHover = false;
          break;
        case 'focus':
          if (that.error) return;
          this.inputFocus = true;

          break;
        case 'blur':
          that.inputFocus = false;
          this.checkSelectInput();
          break;
        default:
          break;
      }
      // this.inputType = result;
    },

    // 下拉框 显示/ 隐藏状态监听
    /**
     * @description 下拉框 显示/ 隐藏状态监听
     * @function visibleChagneHandler
     * @param {String} val 数据
     */
    visibleChagneHandler(val) {
      this.$emit('click');
      this.inputFocus = true;
      if (this.error) return;
      this.selectVisible = val;
      if (val) this.inputFocus = true;
    },
    /**
     * @event input 暴漏input
     * @event change 暴漏change
     */
    /**
     * @description 选项修改
     * @function onSelectChange
     * @param {String} val 数据
     */
    async onSelectChange(val) {
      let label = this.valueToLabel(val) || '';
      this.inputVal = label;
      // v-model 返回 value
      this.$emit('input', String(val));
      // change 返回 label
      this.$emit('change', label);
      this.checkSelectInput();
      if (this.error && this.isVerific) return;
      this.inputFocus = val === '' ? false : true;
    },
    // 检验 选项框 是否为空 否则报错
    checkSelectInput() {
      if (this.isVerific) {
        this.error = this.inputVal === '' ? true : false;
      }
      this.$emit('blur', this.error, this.id, this.errmsg);
    },
    /**
     * @description options 通过value 查找label
     * @function valueToLabel
     * @param {String} val
     * @return {String}
     */
    valueToLabel(val) {
      let label = '';
      const that = this;
      for (let i = 0; i < that.options.length; i++) {
        const item = that.options[i];
        if (item.value === val) {
          label = item.label;
          return label;
        }
      }
    }
  }
};
</script>
<style lang="less" src="./select.less" scoped></style>
<style lang="less">
.el-select-dropdown {
  border-radius: 2px;

  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 1px rgba(0, 0, 0, 0.05) !important;
}
.el-select-dropdown__item {
  color: @color-7C7D80;
  padding-left: 10px !important;
}
.el-select-dropdown__item.hover {
  background-color: @color-FAFAFA;
}
.el-select-dropdown__item.selected {
  color: @color-17181A;
}
</style>
